import { useEffect, useRef, useState } from 'react'
import { SMS_CODE_LENGTH, isAndroid } from '~/shared/config/constants'
import { extractSMSCode } from '~/shared/lib/extractCode'
import SMSReader from './sms-reader'

type UseSMSCodeOptions = {
  length?: number
  onCode: (code: string) => void
}

export const useSMSCode = ({
  length = SMS_CODE_LENGTH,
  onCode,
}: UseSMSCodeOptions) => {
  const [error, setError] = useState<string | null>(null)
  const listenerInitialized = useRef(false)

  useEffect(() => {
    if (!isAndroid || listenerInitialized.current) return

    const setupSMS = async () => {
      try {
        const { granted } = await SMSReader.requestPermissions()
        if (!granted) return

        await SMSReader.startSMSListener()
        listenerInitialized.current = true

        SMSReader.addListener('smsReceived', (result) => {
          if (!result.message) return

          const code = extractSMSCode(result.message, length)
          if (code) {
            onCode(code)
          }
        })
      } catch (error) {
        setError(
          error instanceof Error ? error.message : 'Ошибка при чтении SMS',
        )
      }
    }

    setupSMS()

    return () => {
      if (isAndroid && listenerInitialized.current) {
        SMSReader.stopSMSListener()
        SMSReader.removeAllListeners()
        listenerInitialized.current = false
      }
    }
  }, [onCode, length])

  return { error }
}
